import { useRef, useEffect } from 'react';

var useHideBodyScroll = function useHideBodyScroll(active) {
  var originalStyles = useRef();
  useEffect(function () {
    if (typeof document === 'undefined') return;
    var html = document.documentElement;
    var _document = document,
      body = _document.body;
    if (active) {
      var scrollBarWidth = window.innerWidth - html.clientWidth;
      var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue('padding-right')) || 0;
      var oldStyle = {
        overflow: body.style.overflow,
        paddingRight: body.style.paddingRight
      };
      originalStyles.current = oldStyle;
      body.style.overflow = 'hidden';
      body.style.paddingRight = "".concat(bodyPaddingRight + scrollBarWidth, "px");
    } else if (originalStyles.current) {
      body.style.overflow = originalStyles.current.overflow;
      body.style.paddingRight = originalStyles.current.paddingRight;
    }
    var originalState = originalStyles.current;
    return function () {
      body.style.overflow = originalState === null || originalState === void 0 ? void 0 : originalState.overflow;
      body.style.paddingRight = originalState === null || originalState === void 0 ? void 0 : originalState.paddingRight;
    };
  }, [active]);
};

export { useHideBodyScroll };
